"use strict";

exports.__esModule = true;
var _widget = require("./widget");
Object.keys(_widget).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _widget[key]) return;
  exports[key] = _widget[key];
});
var _DeviceMapHeader = require("./DeviceMapHeader");
Object.keys(_DeviceMapHeader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceMapHeader[key]) return;
  exports[key] = _DeviceMapHeader[key];
});
var _DeviceMapElement = require("./DeviceMapElement");
Object.keys(_DeviceMapElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceMapElement[key]) return;
  exports[key] = _DeviceMapElement[key];
});
var _DeviceMapFields = require("./DeviceMapFields");
Object.keys(_DeviceMapFields).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceMapFields[key]) return;
  exports[key] = _DeviceMapFields[key];
});
var _DeviceMapThumbnail = require("./DeviceMapThumbnail");
Object.keys(_DeviceMapThumbnail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceMapThumbnail[key]) return;
  exports[key] = _DeviceMapThumbnail[key];
});